module.exports = __webpack_public_path__ + "static/media/jackpots-lvl3.a5fd58e3.png";